// extracted by mini-css-extract-plugin
module.exports = {"popoverContainer":"styles_popoverContainer__qYLl6","popoverArrowElement":"styles_popoverArrowElement__8P0It","popoverArrowContainer":"styles_popoverArrowContainer__NMjq0"};